import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HotelRepository } from '@repos/hotel.repository';
import { StarsRateComponent } from '@shared/components/stars-rate/stars-rate.component';
import { ExtractGrade } from '@shared/pipes/extractStarFromClassName.pipe';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';
import { SharedModule } from '@shared/shared.module';
import { BottomNavMobileComponent } from './components/bottom-nav-mobile/bottom-nav-mobile.component';
import { DesktopSearchboxComponent } from './components/desktop-searchbox/desktop-searchbox.component';
import { HotelsCardComponent } from './components/hotels-card/hotels-card.component';
import { MobileSearchboxComponent } from './components/mobile-searchbox/mobile-searchbox.component';
import { ResidenceUnitComponent } from './components/residence-unit/residence-unit.component';
import { ResidencesCardComponent } from './components/residences-card/residences-card.component';
import { HeaderComponent } from './header/header.component';
import { HomePageWrapperComponent } from './home-page-wrapper.component';
import { HomeUiService } from './home-ui.service';
import { EcolodgeWrapperComponent } from './layout-ecolodge/ecolodge-wrapper.component';
import { HotelWrapperComponent } from './layout-hotel/hotel-wrapper.component';
import { AffordableHotelsSectionComponent } from './sections/affordable-hotels-section/affordable-hotels-section.component';
import { BannersComponent } from './sections/banners/banners.component';
import { BenefitsSectionComponent } from './sections/benefits-section/benefits.component';
import { ChainHotelsComponent } from './sections/chain-hotels/chain-hotels.component';
import { IranhotelInfoComponent } from './sections/iranhotel-info/iranhotel-info.component';
import { PopularCitiesComponent } from './sections/popular-cities/popular-cities.component';
import { PopularHotelsSectionComponent } from './sections/popular-hotels-section/popular-hotels-section.component';
import { AffordableHotelsSkeletonComponent } from './skeletons/affordable-hotels-skeleton/affordable-hotels-skeleton.component';
import { HeaderSkeletonComponent } from './skeletons/header-skeleton/header-skeleton.component';
import { HotelCardSkeletonComponent } from './skeletons/hotel-card-skeleton/hotel-card-skeleton.component';
import { PopularHotelsSkeletonComponent } from './skeletons/popular-hotels-skeleton/popular-hotels-skeleton.component';
import { ResidencesSkeletonComponent } from './skeletons/residences-skeleton/residences-skeleton.component';
import { SliderSquaretextViewComponent } from './components/views/slider/slider-squaretext-view/slider-squaretext-view.component';
import { SliderButtonViewComponent } from './components/views/slider/slider-button-view/slider-button-view.component';
import { SliderMultisquareViewComponent } from './components/views/slider/slider-multisquare-view/slider-multisquare-view.component';
import { SliderSlidemenuViewComponent } from './components/views/slider/slider-slidemenu-view/slider-slidemenu-view.component';
import { SliderMulticityViewComponent } from './components/views/slider/slider-multicity-view/slider-multicity-view.component';
import { SlideBannerComponent } from './components/views/banner/main/slide-banner/slide-banner.component';
import { PrimaryBannerComponent } from './components/views/banner/main/primary-banner/primary-banner.component';
import { SingleBannerComponent } from './components/views/banner/single/single-banner.component';
import { EcolodgeTypesComponent } from './components/ecolodge-types/ecolodge-types.component';
import { SliderRentingResidencesComponent } from './components/views/slider/renting-residences-view/renting-residences-view.component';
import { StatesListComponent } from './components/states-list/states-list.component';
import { SliderBgTextComponent } from './components/views/slider/slider-bg-text/slider-bg-text.component';
import { ExploreYourStyleComponent } from './components/explore-your-style/explore-your-style.component';
import { DiscoverAndEarnComponent } from './components/discover-and-earn/discover-and-earn.component';
import { EcolodgeFlexResolver } from './resolvers/home-ecolodge.resolver';
import { EcolodgeTypesSkeletonComponent } from './skeletons/ecolodge-types-skeleton/ecolodge-types-skeleton.component';
import { SliderBgTextSkeletonComponent } from './skeletons/slider-bg-text-skeleton/slider-bg-text-skeleton.component';
import { MapComponent } from '@shared/components/map/map.component';
import { BannersSkeletonComponent } from './skeletons/banners-skeleton/banners-skeleton.component';
import { AboutIhoEcolodgeComponent } from './sections/about-iho-ecolodge/about-iho-ecolodge.component';
import { EcolodgeFaqComponent } from './sections/ecolodge-faq/ecolodge-faq.component';
import { EcolodgeHostBannerComponent } from './sections/ecolodge-host-banner/ecolodge-host-banner.component';
import { SepcialWrapperComponent } from './layout-sepcial/sepcial-wrapper.component';
import { AboutIhoSpecialComponent } from './sections/about-iho-special/about-iho-special.component';
import { EcolodgeFaqSpecialComponent } from './sections/ecolodge-faq-special/ecolodge-faq-special.component';
import { SliderMultisquareViewMshComponent } from './components/views/slider/slider-multisquare-view-msh/slider-multisquare-view-msh.component';

const routes: Routes = [
    {
        path: '',
        component: HomePageWrapperComponent,
        children: [
            {
                path: '',
                component: HotelWrapperComponent,
                resolve: { utm: EcolodgeFlexResolver },
            },
            {
                path: 'ecolodge',
                component: EcolodgeWrapperComponent,
                resolve: { utm: EcolodgeFlexResolver },
            },
            {
                path: 'villa-mashhad',
                component: SepcialWrapperComponent,
                resolve: { utm: EcolodgeFlexResolver },
            },
        ],
    },
];

@NgModule({
    declarations: [
        HomePageWrapperComponent,
        HeaderComponent,
        EcolodgeWrapperComponent,
        SepcialWrapperComponent,
        HotelWrapperComponent,
        BannersComponent,
        PopularHotelsSectionComponent,
        AffordableHotelsSectionComponent,
        BenefitsSectionComponent,
        IranhotelInfoComponent,
        ResidencesSkeletonComponent,
        PopularHotelsSkeletonComponent,
        AffordableHotelsSkeletonComponent,
        HeaderSkeletonComponent,
        SliderRentingResidencesComponent,
        HeaderSkeletonComponent,
        BannersSkeletonComponent,
        EcolodgeHostBannerComponent,
    ],
    providers: [HomeUiService, HotelRepository],
    imports: [
        RouterModule.forChild(routes),
        DesktopSearchboxComponent,
        MobileSearchboxComponent,
        SharedModule,
        HotelsCardComponent,
        RialToTomanPipe,
        BottomNavMobileComponent,
        StarsRateComponent,
        ExtractGrade,
        AboutIhoEcolodgeComponent,
        AboutIhoSpecialComponent,
        EcolodgeFaqSpecialComponent,
        ChainHotelsComponent,
        SliderSquaretextViewComponent,
        SliderButtonViewComponent,
        SliderMultisquareViewComponent,
        SliderSlidemenuViewComponent,
        SliderMulticityViewComponent,
        SliderMultisquareViewMshComponent,
        SlideBannerComponent,
        PrimaryBannerComponent,
        ResidencesCardComponent,
        PopularCitiesComponent,
        ResidenceUnitComponent,
        EcolodgeTypesComponent,
        StatesListComponent,
        SliderBgTextComponent,
        ExploreYourStyleComponent,
        DiscoverAndEarnComponent,
        EcolodgeTypesSkeletonComponent,
        SliderBgTextSkeletonComponent,
        MapComponent,
        SingleBannerComponent,
        EcolodgeFaqComponent,
       
    ],
    exports: [
        SliderSquaretextViewComponent,
        SliderButtonViewComponent,
        SliderRentingResidencesComponent,
        SliderMultisquareViewComponent,
        SliderSlidemenuViewComponent,
        SliderMulticityViewComponent,
        SliderMultisquareViewMshComponent,
        SlideBannerComponent,
        PrimaryBannerComponent,
        ResidencesCardComponent,
        PopularCitiesComponent,
        ResidenceUnitComponent,
        PrimaryBannerComponent,
        SingleBannerComponent,
        EcolodgeTypesComponent,
        EcolodgeTypesSkeletonComponent,
    ],
})
export class HomeModule { }
